import styled, { css } from 'styled-components';

export const ItemContainer = styled.div`
  background-color: #fff;
  display: flex;
  position: relative;
  user-select: none;
  box-sizing: border-box;

  ${({ borderless }) =>
    !borderless &&
    css`
      padding: 20px;
      border: 1px solid #ccc;
    `};

  ${({ readOnly, disabled }) => css`
    pointer-events: ${readOnly || disabled ? 'none' : 'inherit'};
  `};

  &:hover {
    ${({ onClick }) =>
      onClick &&
      css`
        cursor: pointer;
        border-color: #000;
      `};
  }

  ${({ selected }) =>
    selected &&
    css`
      border-color: #000;
      border-width: 2px;
      padding: 19px;
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `};
`;

export const ItemImageContainer = styled.div`
  width: ${({ imageSize }) => (imageSize === 'large' ? '25%' : '100px')};
`;

export const ItemImage = styled.img`
  width: 100%;
`;

export const ItemPropertyContainer = styled.div`
  margin: 12px 0 12px;
`;
export const ItemPropertyList = styled.ul`
  padding: 0;
  list-style: none;
`;
